<template>
    <v-dialog
        v-model="showDialog"
        persistent
        max-width="500px"
    >
        <edit-form
            :report="report"
            :reportType="reportType"
        />
    </v-dialog>

</template>

<script>
import EditForm from "./EditForm";

export default {
    name: "EditDialog",

    components: {EditForm},

    props: {
        showDialog: {
            type: Boolean,
            default: false,
            required: true
        },
        report: {
            type: Object,
            required: true,
        },
        reportType:{
            type: Object,
            required: true,
        }
    },

}
</script>

<style scoped>

</style>
